import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setLoading } from '../features/common/loadingSlice';
import { getMobileAgree, setAgree } from '../features/common/commonSlice';
import Loading from '../components/common/Loading';

//앱에서 로그인 후 key 받아서 처리하는 곳
const Gate = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const session = searchParams.get('key');
  const subUrl = searchParams.get('subUrl');
  const server = searchParams.get('server') || 'jan';

  useEffect(() => {
    console.log('subUrl >>', session && !subUrl);
    if (session) {
      sStorage.setItem('sessionId', session);
      sStorage.setItem('htmAlias', server);
      dispatch(setLoading(false));
      if (!subUrl) {
        dispatch(getMobileAgree())
          .unwrap()
          .then(response => {
            const { resultCode } = response;
            if (Number(resultCode) !== 1) {
              navigate('/terms');
            } else {
              dispatch(setAgree(true));
              navigate('/');
            }
          })
          .catch(error => {
            console.error('약관 체크 오류:', error);
            // 에러 처리
          });
      } else {
        navigate(`/${subUrl}/noHeader`);
      }
      // } else if (session && subUrl) {
      //   console.log(' ???');
      //   sStorage.setItem('sessionId', session);
      //   sStorage.setItem('htmAlias', server);
      //   console.log('server >>', server);
      //   console.log('session >>', session);
      //   console.log('subUrl >>', subUrl);
      //   navigate(subUrl);
    } else {
      dispatch(setLoading(true));
    }
  }, [session, dispatch, navigate]);

  return <Loading />;
};

export default Gate;
